import React from "react";
import { Box, Tooltip } from "@mui/material";

type UnassignedOwnerProps = {
  className?: string;
};

/**
 * Renders the gray em dash "—" for an unassigned owner, inside an MUI Tooltip
 * titled "No owner" and labelled aria-label="No owner". The dash span is
 * focusable (tabIndex={0}) so the tooltip + accessible name are reachable by
 * keyboard and assistive tech.
 */
const UnassignedOwner: React.FC<UnassignedOwnerProps> = ({ className }) => (
  <Tooltip title="No owner">
    <Box
      component="span"
      className={className}
      aria-label="No owner"
      tabIndex={0}
      sx={{ color: "neutral.main" }}
    >
      {"—"}
    </Box>
  </Tooltip>
);

export default UnassignedOwner;
